import React from 'react';
import ReactSwitch from '../../../../../base/components/Switch';
import Icon from '../../../../../base/components/Icon';
import { getTargetLabel } from '../constants';
import styles from '../SettingsNotifications.module.scss';

export const getColumns = (handleEditNotification, handleStatusToggle) => [
    {
        Header: 'ID',
        accessor: 'id',
        className: "bg-white",
        width: 60
    },
    {
        Header: 'Notification Type',
        accessor: 'typeName',
        className: "bg-white",
        width: 120
    },
    {
        Header: 'Time to send',
        accessor: 'timeToSend',
        className: "bg-white",
        width: 120
    },
    {
        Header: 'Title',
        accessor: 'title',
        className: "bg-white",
        Cell: ({ value }) => <div title={value}>{value}</div>,
        width: 180
    },
    {
        Header: 'Body',
        accessor: 'body',
        className: "bg-white",
        Cell: ({ value }) => (
            <div
                className={styles.bodyCell}
                title={value}
            >
                {value}
            </div>
        ),
        width: 220
    },
    {
        Header: 'Target',
        accessor: 'target',
        className: "bg-white",
        Cell: ({ value }) => <div>{getTargetLabel(value)}</div>,
        width: 120
    },
    {
        Header: 'Actions',
        id: 'actions',
        className: "bg-white",
        Cell: ({ row }) => (
            <div className={styles.actionsContainer}>
                <Icon icon="edit"
                      width={20}
                      height={20}
                      className={`${styles.editIcon} impacts-section__view`}
                      onClick={(event) => {
                          event.stopPropagation();
                          handleEditNotification(row.original);
                      }}
                />
                <ReactSwitch
                    state={row.original.isActive}
                    updateState={() => handleStatusToggle(row.original.id, row.original.isActive)}
                    onText=""
                    offText=""
                    switchWidth={50}
                />
            </div>
        ),
        width: 140,
        disableSortBy: true
    }
];